'use client'

import { openModalUserlogin } from '@/utils/aside'
import { useContextElement } from '@/context/Context'
import { useRouter } from 'next/navigation'

export default function User({ headerStyle }) {
  const router = useRouter()
  const { isLogin } = useContextElement()

  const handleClick = () => {
    if (isLogin) {
      // 已登入：導向會員專區
      router.push('/MemberCenter/account_dashboard')
    } else {
      // 未登入：開登入 modal
      openModalUserlogin()
    }
  }

  return (
    <svg
      onClick={handleClick}
      className="d-block"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      style={{ color: headerStyle?.HeaderFontColor || '#000' }}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <use href="#icon_user" />
    </svg>
  )
}
